<template>
	<div ref="foto" v-parallax-fit="parallax" class="foto">
		<!-- <img src="/themes/rise-theme/dist/images/estate/character-view/ozzie/27_FinalPhoto_03@2x.png" alt=""> -->
	</div>
</template>

<script>
	export default {
		data() {
			return {
				mutationObserver: null,
				parallax: [
					{
						start: 36200,
						end: 37200,
						fromStyle: { transform: 'translateY(-1000%) translateX(0%)' },
           				toStyle: { transform: 'translateY(0%) translateX(0%)' },
						easing: 'linear'
					}
				]
			}
		},
		mounted() {
			const self = this;
			const evidence = {
			    items: [
			        {
			        	image: '/themes/rise-theme/dist/images/estate/character-view/ozzie/evidence/9a.png',
			          	url: 'https://bigthink.com/the-present/detroit-shrinking-city/',
			          	link_title: {
							'en': "Do not bid!”: The fight to stop homeownership collapse in Detroit",
							'es': '¡No oferte!”: La lucha para detener el colapso de la propiedad de vivienda en Detroit'
						},
			        },
			        {
			        	image: '/themes/rise-theme/dist/images/estate/character-view/ozzie/evidence/9b.png',
			          	url: 'https://detroitaction.org/',
			          	link_title: {
							'en': "Detroit Action",
							'es': 'Acción de Detroit'
						},
			        }
			    ],
			    text: {
					'en': 'Detroit Action is a union of Black and Brown, low and no-income, homeless and housing insecure Detroiter fighting for housing and economic justice...Detroit Action provides opportunities for individuals and families to develop as full human beings through our leadership development workshops, organizer internships, nonpartisan voter education and mobilization drives, direct action, and collaboration with allied organizations locally, statewide, nationally, and even internationally.',
					'es': 'Detroit Action es una unión de negros y morenos, de bajos ingresos o sin ingresos, sin hogar y con viviendas inseguras de Detroit que luchan por la vivienda y la justicia económica... Detroit Action brinda oportunidades para que las personas y las familias se desarrollen como seres humanos completos a través de nuestros talleres de desarrollo de liderazgo, pasantías de organizadores, campañas de movilización y educación de votantes no partidistas, acción directa y colaboración con organizaciones aliadas a nivel local, estatal, nacional e incluso internacional.'
				}
		    };

		    const text = {
				'en': "While Oswaldo was able to recover his home, the fight continues for many more Detroiters at risk of unfair foreclosure. Today, housing justice advocates across the city are fighting to keep people in their homes and transform Detroit into a city where the opportunity of stability is meant for all, not just the few.",
				'es': 'Si bien Oswaldo pudo recuperar su casa, la lucha continúa para muchos más habitantes de Detroit que corren el riesgo de una ejecución hipotecaria injusta. Hoy, los defensores de la justicia de vivienda en toda la ciudad están luchando para mantener a las personas en sus hogares y transformar a Detroit en una ciudad donde la oportunidad de estabilidad sea para todos, no solo para unos pocos.'
			};

			this.mutationObserver = new window.MutationObserver(mutationList => {
			   	mutationList.forEach( mutation => {
			        if (mutation.target.style.transform == 'translateY(0%) translateX(0%)') {
			        	this.$evidence.value = JSON.stringify(evidence);
		    			this.$readMore.value = text;
			        }
			    });
		    });

		    this.mutationObserver.observe(this.$refs.foto, {
		    	attributes: true,
		    	attributeFilter: ['style']
		    });
		},
		unmounted() {
		    this.mutationObserver.disconnect();
		}
	}
</script>

<style lang="scss" scoped>
	.foto {
		position: absolute;
		left: 0;
		top: 0;
		max-width: 400px;
		z-index: 3;
		margin-left: 105px;
		margin-top: 106px;
		transition: all 0.5s linear;
	}

	@media screen and (max-width: 991px) {
		.foto {
		    max-width: 300px;
		    margin-left: 87px;
		    margin-top: 106px;
		}
	}

	@media screen and (max-width: 650px) {
		.foto {
			max-width: 200px;
		    margin-left: 55px;
		    margin-top: 58px;
		}
	}
</style>
